module.exports = __webpack_public_path__ + "037ffd7ec08609850ce062a3caa8d9c6.png";